export default __webpack_public_path__ + "static/media/centerActiveSvg.37b3b6f2.svg";